export default {
  placeholder: 'Nenhum',
};
